export const SchemaProvider = {
    "conversation": {
        "auto_scroll_on_rating_change": true,
        "is_new_component_editor": true,
        "brand_id": null,
        "version": null,
        "default_device": "desktop",
        "devices": {
            "phone": {
                "is_touch_enabled": true
            },
            "desktop": {
                "is_touch_enabled": false
            },
            "tablet": {
                "is_touch_enabled": true
            }
        },
        "footer_style": {
            "is_per_group": true,
            "hide_logo": false
        },
        "enable_back_button": true,
        "default_language": "english",
        "languages": {
            "english": {
                "display_name": "English",
                "language": "English",
                "time": 0,
                "labels": {
                    "label-header": "Provide label for header"
                }
            }
        },
        "header": {
            "is_fixed": true,
            "label": "label-header"
        },
        "screens": {
            "phone": {
                "english": []
            },
            "desktop": {
                "english": []
            },
            "tablet": {
                "english": []
            }
        },
        "flows": {
            "phone": {
                "english": []
            },
            "desktop": {
                "english": []
            },
            "tablet": {
                "english": []
            }
        },
        "expired_flows": {
            "phone": {
                "english": []
            },
            "desktop": {
                "english": []
            },
            "tablet": {
                "english": []
            }
        },
        "archive_flows": {
            "phone": {
                "english": []
            },
            "desktop": {
                "english": []
            },
            "tablet": {
                "english": []
            }
        },
        "custom_styles": [],
        "custom_scripts": [],
        "fields": [],
        "footer":{}
    },
    "channels": {
        "feedbacks": {
            "url": null,
            "customer_notification_singlenotificationperday": null,
            "expiration_delay": null,
            "process_interval_time": null,
            "date_limit_interval": null,

            // deduplication_config_object to set dedup logic based on tag data
            "deduplication_config_object": {
                "dedup_field_ids": null,
                "deduplication_java_class_name": null,

            },
            "sms": {
                "sms_config_generator_class": null,
                "default_language": null,
                "english": {
                    "sender_id": null,
                    "template": null,
                    "provider": null,
                }
            },
            "email": {
                "email_config_generator_class": null,
                "default_language": null,
                "english": {
                    "subject": null,
                    "from": null,
                    "provider": null,
                    "template_id": null,
                }
            },
            "trial_params": {
                "attempts": null,
                "trial_1": {
                    "type_info": null,
                    "type": null,
                    "time": null,
                    "cron_str_list": null,
                    "based_on": null,
                    "default_language": null,
                    "email": {
                        "email_config_generator_class": null,
                        "english": {
                            "subject": null,
                            "from": null,
                            "provider": null,
                            "template_id": null,
                        }
                    },
                    "sms": {
                        "sms_config_generator_class": null,
                        "default_language": null,
                        "english": {
                            "sender_id": null,
                            "template": null,
                            "provider": null,
                        }
                    }
                }
            }
        }
    },
    "components": {
        // creating default Value object for different input types for Single line input box.
        "inputbox": {
            "text": {
                "_ltmsLabelPlaceholder": "",
                "_ltmsLabelValidationMessage": "",
                "_ltmsLabelValidationRegxMessage": "",
                "autoTrim": true,
                "className": "",
                "defaultTagValue": "",
                "inputType": "text",
                "isSubQuestion": false,
                "maxLength": "",
                "minimumCharacters": "5",
                "validationRegx": "",
                "_ltmsLabelInfoMessage":""
            },
            "number": {
                "_ltmsLabelPlaceholder": "",
                "_ltmsLabelValidationMessage": "",
                "_ltmsLabelValidationRegxMessage": "",
                "autoTrim": true,
                "className": "",
                "defaultTagValue": "",
                "inputType": "number",
                "isSubQuestion": false,
                "maxLength": "",
                "minimumCharacters": "",
                "validationRegx": ""
            },
            "tel": {
                "_ltmsLabelPlaceholder": "Enter Mobile Number",
                "_ltmsLabelValidationMessage": "Enter Valid Mobile Number",
                "_ltmsLabelValidationRegxMessage": "Enter Valid Mobile Number",
                "autoTrim": true,
                "className": "",
                "defaultTagValue": "",
                "inputType": "tel",
                "isSubQuestion": false,
                "maxLength": 13,
                "minimumCharacters": 10,
                "validationRegx": "^(\\+91[\\-\\s]?)?[0]?(91)?[6789]\\d{9}$"
            },
            "email": {
                "_ltmsLabelPlaceholder": "Enter Email Address",
                "_ltmsLabelValidationMessage": "Enter Valid Email",
                "_ltmsLabelValidationRegxMessage": "Enter Valid Email",
                "autoTrim": true,
                "className": "",
                "defaultTagValue": "",
                "inputType": "email",
                "isSubQuestion": false,
                "maxLength": "",
                "minimumCharacters": 3,
                "validationRegx": "([a-zA-Z0-9_.]{3}[a-zA-Z0-9_.]*)((@[a-zA-Z]{2}[a-zA-Z]*)[\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))"
            },
            "default": {
                "_ltmsLabelPlaceholder": "",
                "_ltmsLabelValidationMessage": "",
                "_ltmsLabelValidationRegxMessage": "",
                "autoTrim": true,
                "className": "",
                "defaultTagValue": "",
                "inputType": "",
                "isSubQuestion": false,
                "maxLength": "",
                "minimumCharacters": "",
                "validationRegx": ""
            },
            "date": {
                "_ltmsLabelPlaceholder": "",
                "_ltmsLabelValidationMessage": "",
                "_ltmsLabelValidationRegxMessage": "",
                "autoTrim": true,
                "className": "",
                "defaultTagValue": "",
                "inputType": "date",
                "isSubQuestion": false,
                "maxLength": "",
                "minimumCharacters": "",
                "validationRegx": "",
                "minDate": "",
                "maxDate": "",
                "storeCurrentDateAsMaxDate":false
            }
        },
        "single_multi_select_default": {
            "block": {
                "displayType": "block",
                "showRandomly": false,
                "inactiveBackgroundColor": "#ffffff",
                "inactiveFontColor": "#222222",
                "inactiveFontSize": "16px",
                "activeBackgroundColor": "#66B846",
                "activeFontColor": "#222222",
                "activeFontSize": "16px",
                "className": "",
                "isDisplayErrorMessage": true,
                "_ltmsLabelErrorMessage": "Please select an option.",
                "errorMessageColor": "#C42031",
                "errorMessagefontSize": "13px",
                "fontFamily": "",
                "defaultValues": ""
            },
            "inline": {
                "displayType": "inline",
                "showRandomly": false,
                "inactiveBackgroundColor": "#ffffff",
                "inactiveFontColor": "#222222",
                "inactiveFontSize": "16px",
                "activeBackgroundColor": "#66B846",
                "activeFontColor": "#222222",
                "activeFontSize": "16px",
                "className": "",
                "isDisplayErrorMessage": true,
                "_ltmsLabelErrorMessage": "Please select an option.",
                "errorMessageColor": "#C42031",
                "errorMessagefontSize": "13px",
                "fontFamily": "",
                "defaultValues": ""
            },
            "square": {
                "displayType": "square",
                "showRandomly": false,
                "inactiveBackgroundColor": "#ffffff",
                "inactiveFontColor": "#222222",
                "inactiveFontSize": "16px",
                "activeBackgroundColor": "#0B7139",
                "activeFontColor": "#222222",
                "activeFontSize": "16px",
                "className": "",
                "isDisplayErrorMessage": true,
                "_ltmsLabelErrorMessage": "Please select an option.",
                "errorMessageColor": "#C42031",
                "errorMessagefontSize": "13px",
                "fontFamily": "",
                "defaultValues": ""
            },
            "circular": {
                "displayType": "circular",
                "showRandomly": false,
                "inactiveBackgroundColor": "#ffffff",
                "inactiveFontColor": "#222222",
                "inactiveFontSize": "16px",
                "activeBackgroundColor": "#207F36",
                "activeFontColor": "#222222",
                "activeFontSize": "16px",
                "className": "",
                "isDisplayErrorMessage": true,
                "_ltmsLabelErrorMessage": "Please select an option.",
                "errorMessageColor": "#C42031",
                "errorMessagefontSize": "13px",
                "fontFamily": "",
                "defaultValues": ""
            },
            "dropdown": {
                "displayType": "dropdown",
                "showRandomly": false,
                "inactiveBackgroundColor": "#ffffff",
                "inactiveFontColor": "#222222",
                "inactiveFontSize": "16px",
                "activeBackgroundColor": "#66B846",
                "activeFontColor": "#222222",
                "activeFontSize": "16px",
                "className": "",
                "isDisplayErrorMessage": true,
                "_ltmsLabelErrorMessage": "Please select an option.",
                "errorMessageColor": "#C42031",
                "errorMessagefontSize": "13px",
                "fontFamily": "",
                "defaultValues": ""
            }
        }
    }
} 